import React, { useState } from 'react';
import './ValentineLanding.css';

function ValentineLanding({ onStartQuiz }) {
  const [isHovered, setIsHovered] = useState(null);

  const handleButtonClick = (answer) => {
    // Both "Yes" and "Maybe" lead to the quiz - the real test!
    onStartQuiz();
  };

  return (
    <div className="valentine-landing">
      <div className="content-container fade-in">
        <div className="heart-decoration pulse">
          <div className="heart"></div>
        </div>
        
        <h1 className="main-title slide-in">
          My Dearest Christine
        </h1>
        
        <div className="subtitle slide-in">
          (My beloved Steeny)
        </div>
        
        <div className="romantic-message fade-in">
          <p>
            From our magical wedding in Croatia to our cozy life with Niko and Mala,
            from honeymoon adventures in Switzerland and Portugal to building our 
            dream home together...
          </p>
          <p className="main-question">
            Will you be my Valentine?
          </p>
        </div>
        
        <div className="buttons-container fade-in">
          <button 
            className={`valentine-button yes-button ${isHovered === 'yes' ? 'hovered' : ''}`}
            onMouseEnter={() => setIsHovered('yes')}
            onMouseLeave={() => setIsHovered(null)}
            onClick={() => handleButtonClick('yes')}
          >
            <span className="button-text">Yes, Forever</span>
          </button>
          
          <button 
            className={`valentine-button maybe-button ${isHovered === 'maybe' ? 'hovered' : ''}`}
            onMouseEnter={() => setIsHovered('maybe')}
            onMouseLeave={() => setIsHovered(null)}
            onClick={() => handleButtonClick('maybe')}
          >
            <span className="button-text">Perhaps...</span>
          </button>
        </div>
        

      </div>
      

    </div>
  );
}

export default ValentineLanding;
